import React, { useState, useEffect } from "react"
import { reactLocalStorage } from "reactjs-localstorage"
import { deliveryCharges } from "../data/store"

const CartContext = React.createContext()

const CartProvider = props => {
  const [cart, updateCart] = useState({items:[], selectedDelivery: deliveryCharges[0]});

  useEffect(() => {
    let storedCart = reactLocalStorage.getObject("cart")
    if (Object.entries(storedCart).length === 0) {
      storedCart = {items:[], selectedDelivery: deliveryCharges[0]};
    }
    else {
      if(storedCart.selectedDelivery === null){
        storedCart.selectedDelivery = deliveryCharges[0];
      }
    }
    updateCart(storedCart);
  }, []);

  useEffect(() => {
    //console.log("cart", cart);
  }, [cart]);

  return (
    <CartContext.Provider value={[cart, updateCart]}>
      {props.children}
    </CartContext.Provider>
  )
}

export { CartContext, CartProvider }
